import axios from 'axios';
import { baseUrl } from './constants';
import { getToken } from './tokens';

export async function getKw(query){
    const token = getToken();
    const {data} = await axios.get(
      `${baseUrl}/dashboard/kw?${query}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return data;
}